import { useEffect } from "react";
import { useMotionValue } from "framer-motion";

export function useScrollVelocity() {
  const velocity = useMotionValue(0);
  useEffect(() => {
    let lastY = window.scrollY;
    let lastT = performance.now();
    const onScroll = () => {
      const now = performance.now();
      const dy = window.scrollY - lastY;
      const dt = Math.max(now - lastT, 1);
      velocity.set(dy / dt);
      lastY = window.scrollY;
      lastT = now;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [velocity]);
  return velocity;
}
